import React from 'react';
import { ErrorMessage } from 'formik';

const Checkbox = (props) => {
  const {
    field: { name, value, onChange, onBlur },
    form: { touched, setFieldValue },
    label,
    disabled,
    handleChange = () => {},
  } = props;
  const handleAffectedFields = (affectedFields) => {
    if (affectedFields) {
      Object.keys(affectedFields).forEach((key) => setFieldValue(key, affectedFields[key]));
    }
  };
  return (
    <div className="custom-control custom-checkbox" id={`${name}-div-checkbox`}>
      <input
        name={name}
        id={`${name}-checkbox`}
        type="checkbox"
        value={value}
        checked={value}
        onChange={(e) => {
          onChange(e);
          const newValue = e.target.checked;
          const changedFields = handleChange(newValue);
          handleAffectedFields(changedFields);
        }}
        onBlur={onBlur}
        className="custom-control-input"
        disabled={disabled}
      />
      <label htmlFor={`${name}-checkbox`} className="custom-label custom-control-label" id={`${name}-checkbox-label`}>
        {label}
      </label>
      {touched[name] && <ErrorMessage name={name} component="div" className="invalid-feedback" id={`${name}-checkbox-error-message`} />}
    </div>
  );
};

export default Checkbox;
